import { ApplicationRef, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private _notification: BehaviorSubject<
    NotificationMessageModel
  > = new BehaviorSubject(null);
  readonly notification$: Observable<
    NotificationMessageModel
  > = this._notification.asObservable();
  constructor(private appRef: ApplicationRef) {}
  notify(message: string) {
    this._notification.next({ message, shouldShow: true });
    this.appRef.tick();
    setTimeout(() => {
      this._notification.next({ message, shouldShow: false });
      this.appRef.tick();
    }, 3000);
  }
}
export interface NotificationMessageModel {
  message: string;
  shouldShow?: boolean;
}
